import { render, staticRenderFns } from "./TasksWidget.vue?vue&type=template&id=ae3d324a&scoped=true&"
import script from "./TasksWidget.vue?vue&type=script&setup=true&lang=js&"
export * from "./TasksWidget.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3d324a",
  null
  
)

export default component.exports